<template>
<div class="list-group-item list-group-item-action">
  <div class="d-flex w-100 justify-content-between">
    <h3 class="h6 mb-1">{{ noteAuthor }}</h3>
    <small><app-date-time :date-str="note.created_at" /></small>
  </div>
  <p class="my-1" style="white-space: pre-line;">{{ note.comment }}</p>
</div>
</template>

<script>
export default {
  name: 'DeviceLoanNoteItem',
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  computed: {
    author() {
      return this.note.user
    },
    noteAuthor() {
      return this.author ? this.author.name : 'System'
    }
  }
}
</script>
